import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import { getErrorMessage } from '../Rssi/errorHandler.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import { isIos } from '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import client from '../../services/graphql/client.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import { useGetPinchZoomUtils } from '../../services/hooks/useGetPinchZoomUtils.js';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import PasswordStep from './PasswordStep.js';
import styles from './AccessToken.module.scss.js';
import { generatAccessTokenAsync } from './accessTokenSlice.js';
import SmsStep from './SmsStep.js';

var AccessTokenPanel = function AccessTokenPanel(_ref) {
  var instance = _ref.instance;
  var dispatch = useDispatch();
  var panel = instance.panel,
    onValidate = instance.onValidate,
    giid = instance.giid,
    openForgotPasswordModal = instance.openForgotPasswordModal,
    removeSubPanel = instance.removeSubPanel,
    _instance$header = instance.header,
    header = _instance$header === void 0 ? t('MPLIB_DEFAULT_IDENTIFY') : _instance$header,
    _instance$client = instance.client,
    client$1 = _instance$client === void 0 ? client : _instance$client;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    userPassword = _useState2[0],
    setUserPassword = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    smsSent = _useState4[0],
    setSmsSent = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    smsToken = _useState6[0],
    setSmsToken = _useState6[1];
  var verifyDisabled = !smsSent || !smsToken;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isVerifying = _useState8[0],
    setIsVerifying = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useGetPinchZoomUtils = useGetPinchZoomUtils(),
    enablePinchZoom = _useGetPinchZoomUtils.enablePinchZoom,
    disablePinchZoom = _useGetPinchZoomUtils.disablePinchZoom;
  var closeModal = function closeModal() {
    dispatch(removeSubPanel(panel));
  };
  var handleSmsVerify = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$generatAccessT, token, _getErrorMessage, description;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsVerifying(true);
              _context.prev = 1;
              _context.next = 4;
              return generatAccessTokenAsync(giid, client$1, {
                userPassword: userPassword,
                smsToken: smsToken
              });
            case 4:
              _yield$generatAccessT = _context.sent;
              token = _yield$generatAccessT.token;
              onValidate(token);
              closeModal();
              _context.next = 15;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              _getErrorMessage = getErrorMessage()(_context.t0), description = _getErrorMessage.description;
              setError(description);
              setIsVerifying(false);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function handleSmsVerify() {
      return _ref2.apply(this, arguments);
    };
  }();

  // eslint-disable-next-line consistent-return
  useEffect(function () {
    if (isIos) {
      disablePinchZoom();
      return function () {
        enablePinchZoom();
      };
    }
  }, [isIos]);
  var handleEnterKey = function handleEnterKey(event) {
    if (event.key === 'Enter' && !error && !verifyDisabled && !isVerifying) {
      handleSmsVerify();
    }
  };
  useEffect(function () {
    document.addEventListener('keydown', handleEnterKey, {
      once: true
    });
    return function () {
      return document.removeEventListener('keydown', handleEnterKey);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper,
    id: "AccessTokenPanel"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, header), !smsSent ? /*#__PURE__*/React.createElement(PasswordStep, {
    openForgotPasswordModal: openForgotPasswordModal,
    userPassword: userPassword,
    setUserPassword: setUserPassword,
    setSmsSent: setSmsSent,
    client: client$1
  }) : /*#__PURE__*/React.createElement(SmsStep, {
    setSmsToken: setSmsToken,
    smsToken: smsToken
  }), error && /*#__PURE__*/React.createElement("p", {
    className: styles.passwordError
  }, error), /*#__PURE__*/React.createElement("div", {
    className: styles.optionButtons
  }, /*#__PURE__*/React.createElement(Button, {
    text: t("MPLIB_CANCEL"),
    onClick: closeModal,
    className: styles.optionButton,
    flat: true,
    cancel: true
  }), /*#__PURE__*/React.createElement(Button, {
    dataTestId: "verifySms",
    text: t("MPLIB_VERIFY"),
    onClick: handleSmsVerify,
    className: styles.optionButton,
    disabled: verifyDisabled || isVerifying,
    flat: true,
    isLoading: isVerifying
  }))));
};
AccessTokenPanel.propTypes = {
  instance: PropTypes.shape({
    panel: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    giid: PropTypes.string.isRequired,
    removeSubPanel: PropTypes.func.isRequired,
    openForgotPasswordModal: PropTypes.func.isRequired,
    client: PropTypes.shape({
      query: PropTypes.func.isRequired,
      mutate: PropTypes.func.isRequired
    }),
    header: PropTypes.string
  }).isRequired
};

export { AccessTokenPanel as default };
